import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Shared inner-page header. Back on the left (labelled with destination),
 * centred H1, actions on the right. Constrains content to 960px max.
 */
export default function PageHeader({ backTo, backLabel = "Back", title, actions, testId = "page-header" }) {
  const navigate = useNavigate();
  return (
    <header className="nb-border border-l-0 border-r-0 border-t-0 bg-white dark:bg-zinc-900 sticky top-0 z-30" data-testid={testId}>
      <div className="max-w-[960px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <button
          onClick={() => (backTo === -1 ? navigate(-1) : navigate(backTo || "/"))}
          data-testid="page-back"
          aria-label={`Back to ${backLabel}`}
          className="nb-button px-3 py-2 text-sm flex items-center gap-2 flex-shrink-0"
        >
          <ArrowLeft className="w-4 h-4" aria-hidden="true" /> {backLabel}
        </button>
        <h1 className="font-display font-black text-xl sm:text-2xl text-center truncate flex-1 min-w-0" data-testid="page-title">
          {title}
        </h1>
        <div className="flex items-center gap-2 flex-shrink-0">
          {actions}
        </div>
      </div>
    </header>
  );
}
